module.exports = __webpack_public_path__ + "img/電気回路_6_5_4.f44b611c.png";